<template>
  <div class="bills-card">
    <div class="card-header">
      <div class="header-content">
        <h3 class="card-title">
          <i class="fas fa-file-invoice-dollar title-icon"></i>
          Contas a pagar
        </h3>
        <div class="header-actions">
          <v-btn
            @click="handleToSpentOrGain"
            class="action-btn expense-btn"
            small
          >
            <i class="fas fa-minus mr-1"></i>
            <i class="fas fa-dollar-sign"></i>
          </v-btn>
          <v-btn class="action-btn view-all-btn" small @click="handleToList">
            <i class="fas fa-calendar-alt mr-1"></i>
            {{ moment().format("MMMM") }}
          </v-btn>
        </div>
      </div>
    </div>

    <div class="card-content">
      <ErrorsMessages :errors="errors" />

      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <div v-show="data.length == 0" class="no-results">
          <i class="fas fa-check-circle no-results-icon"></i>
          <h4 class="no-results-title">Nenhuma conta pendente</h4>
          <p class="no-results-text">Todas as contas estão em dia!</p>
        </div>

        <div v-show="data.length > 0" class="bills-list">
          <div
            v-for="(item, key) in data"
            :key="key"
            class="bill-item"
            :class="{ 'late-payment': item.late_payment }"
          >
            <div class="bill-info">
              <div class="bill-icon">
                <i
                  :class="[
                    'fas',
                    item.late_payment
                      ? 'fa-exclamation-triangle'
                      : 'fa-file-invoice',
                  ]"
                ></i>
              </div>
              <div class="bill-details">
                <div class="bill-description">
                  {{ item.description }}
                  <span
                    v-if="item.is_repeat == 'MAIS_DE_UMA_VEZ'"
                    class="repeat-indicator"
                  >
                    [{{ item.index_key }}/{{ item.how_many_times }}]
                  </span>
                </div>
                <div class="bill-date">
                  <i class="fas fa-calendar mr-1"></i>
                  {{ item.date }}
                </div>
              </div>
            </div>

            <div class="bill-actions">
              <div class="bill-amount">
                <span
                  v-if="item.is_spent_or_gain == 'CREDITO'"
                  class="amount-positive"
                >
                  {{ formatMoney(String(item.value)) }}
                </span>
                <span
                  v-if="item.is_spent_or_gain == 'DEBITO'"
                  class="amount-negative"
                >
                  -{{ formatMoney(String(item.value)) }}
                </span>
              </div>
              <v-btn
                :class="[
                  'pay-btn',
                  !item.late_payment ? 'pay-btn-normal' : 'pay-btn-late',
                ]"
                small
                @click="handleToPay(item)"
              >
                <i class="fas fa-credit-card mr-1"></i>
                {{ item.type == "CONTAS_A_PAGAR" ? "Pagar" : "Receber" }}
              </v-btn>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";
import api from "../../../services/api";
import { formatMoney } from "../../../lib/format";
import moment from "moment";

export default {
  name: "BillsToPay",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      data: [],
      errors: [],
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    moment,
    formatMoney,
    handleToSpentOrGain() {
      this.$emit("handle_to_releases", { launch: "spent" });
    },
    handleToList() {
      this.$emit("handle_to_releases");
    },
    handleToPay(item) {
      this.$emit("pay", {
        id: item.id,
        date: item.due_date,
      });
    },
    async retrieve() {
      try {
        this.loading = true;

        let params = { type: "CONTAS_A_PAGAR" };

        const response = await api.get("/rest-home/financial/overview/bills", {
          params,
        });

        const { data } = response.data;

        this.data = data;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.bills-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  height: fit-content;
}

.card-header {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #f59e0b;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #92400e;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #d97706;
  margin-right: 8px;
  font-size: 16px;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  font-size: 11px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.expense-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: white !important;
  border: none !important;
}

.view-all-btn {
  background: linear-gradient(135deg, #1f5a76 0%, #0f4c75 100%) !important;
  color: white !important;
  border: none !important;
}

.card-content {
  padding: 24px;
  max-height: 400px;
  overflow-y: auto;
}

.loading-overlay {
  border-radius: 12px;
  min-height: 200px;
}

.no-results {
  text-align: center;
  padding: 40px 24px;
}

.no-results-icon {
  font-size: 48px;
  color: #10b981;
  margin-bottom: 16px;
}

.no-results-title {
  color: #1e293b;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.no-results-text {
  color: #6b7280;
  font-size: 14px;
  margin: 0;
}

.bills-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bill-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  gap: 16px;
}

.bill-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

.bill-item.late-payment {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-color: #fca5a5;
}

.bill-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.bill-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: white;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.late-payment .bill-icon {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.bill-details {
  flex: 1;
  min-width: 0;
}

.bill-description {
  font-weight: 500;
  color: #1e293b;
  font-size: 14px;
  margin-bottom: 4px;
  word-break: break-word;
}

.repeat-indicator {
  font-size: 12px;
  color: #6b7280;
  font-weight: 400;
}

.bill-date {
  font-size: 12px;
  color: #6b7280;
  display: flex;
  align-items: center;
}

.bill-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.bill-amount {
  font-weight: 600;
  font-size: 14px;
}

.amount-positive {
  color: #10b981;
}

.amount-negative {
  color: #ef4444;
}

.pay-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.pay-btn-normal {
  background: linear-gradient(135deg, #1d75be 0%, #155a8a 100%) !important;
  color: white !important;
  border: none !important;
}

.pay-btn-late {
  background: linear-gradient(135deg, #f88a14 0%, #d97706 100%) !important;
  color: white !important;
  border: none !important;
}

/* Scrollbar personalizada */
.card-content::-webkit-scrollbar {
  width: 6px;
}

.card-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.card-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.card-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .card-content {
    padding: 16px;
  }

  .bill-item {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .bill-actions {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .bill-icon {
    width: 36px;
    height: 36px;
  }
}
</style>